import styled from 'styled-components'
import media from 'styled-media-query'

export const MenuItem = styled.li`
  position: relative;
  display: ${props  => (props.visible ? 'none' : 'flex')};
  align-items: center;
  list-style-type: none;
  line-height: 2.6;
  cursor: pointer;
`

export const MenuLink = styled.a`
  /* ✏️ Text */
  position: static;
  height: 16px;
  left: 0px;
  right: 0px;
  top: calc(50% - 16px/2);

  /* Desktop/Text-Action/SM */
  font-family: ${props => props.theme.font};
  font-size: 14px;
  font-weight: bold;
  line-height: 115%;
  /* identical to box height, or 16px */
  text-align: center;

  /* Interaction/Select/: Default */
  color: ${props => props.theme.header.text};

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 33px;
  ${media.lessThan('large')`
    margin-left: 15px;
    margin-right: 15px;
  `}


  text-decoration: none;
  opacity: 1;


  &:hover {
    opacity: 0.8;
  }
`
export const SubmenuTitle = styled.p`
  /* Desktop/Text-Action/SM */
  font-family: ${props => props.theme.font};
  font-size: 14px;
  font-weight: bold;
  line-height: 115%;
  /* identical to box height, or 16px */
  text-align: center;

  /* Interaction/Select/: Default */
  color: ${props => props.theme.header.text};

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  margin: 33px;
  ${media.lessThan('large')`
    margin-left: 15px;
    margin-right: 15px;
  `}

  opacity: 1;

  &:hover {
    opacity: 0.8;
  }
`
